"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getRegionalConfigurationRequest_1 = require("owa-service/lib/factory/getRegionalConfigurationRequest");
var getRegionalConfigurationOperation_1 = require("owa-service/lib/operation/getRegionalConfigurationOperation");
function getRegionalConfiguration() {
    return getRegionalConfigurationOperation_1.default(getRegionalConfigurationRequest_1.default({}));
}
exports.default = getRegionalConfiguration;
//# sourceMappingURL=getMailboxRegionalConfiguration.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/general/owa-regional-option/lib/services/getMailboxRegionalConfiguration.js
// module id = 4920
// module chunks = 2